import {
  Button,
  Flex,
  InputSearch,
  ModalContext,
  PaginationPerPageSelect,
  SearchContext,
} from "dash-ui";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";

const ApiCompaniesPageHeader = () => {
  const { t } = useTranslation(["common", "pages"]);
  const { setSearchSlug } = useContext(SearchContext);
  const { toggleModal } = useContext(ModalContext);
  const [search, setSearch] = useState("");

  return (
    <Flex alignItems="center" w="100%" px={6} py={4}>
      <InputSearch
        value={search}
        onChange={(event) => {
          setSearch(event.target.value);
          setSearchSlug(event.target.value);
        }}
        onClear={() => {
          setSearch("");
          setSearchSlug("");
        }}
        w="100%"
        css={"height: 40px"}
        placeholder={t("common:labels.search") || ""}
      />
      <PaginationPerPageSelect
        w={130}
        mx={3}
        label={t("common:labels.show") || ""}
      />
      <Button
        minWidth={240}
        icon="plus"
        onClick={() => toggleModal(true, "AddDashAPIUser")}
      >
        {t("pages:apiUsersPage.addNewUserButton")}
      </Button>
    </Flex>
  );
};

export default ApiCompaniesPageHeader;
